export default "__VITE_ASSET__DRcXRj5K__"